"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _TypographyWrapper = _interopRequireDefault(require("../styled/TypographyWrapper"));
var _constants = require("../constants");
var _excluded = ["children", "theme", "forwardedRef"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Typography = function Typography(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    forwardedRef = _ref.forwardedRef,
    pasThroughProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_TypographyWrapper["default"], _extends({}, pasThroughProps, {
    ref: forwardedRef
  }), children));
};
Typography.propTypes = {
  /**
   * Theme object
   */
  theme: _propTypes["default"].object.isRequired,
  /**
   * Rendered elements
   */
  children: _propTypes["default"].node,
  /**
   * Color
   */
  color: _propTypes["default"].string,
  /**
   * Predefined font weights(default, attention, max) or pass any possible CSS value
   */
  weight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].oneOf(Object.keys(_constants.weights))]),
  /**
   * CSS display
   */
  display: _propTypes["default"].string,
  /**
   * Define if text should wrap or truncate with ellipsis
   */
  shouldWrap: _propTypes["default"].bool,
  /**
   * CSS text-align
   */
  align: _propTypes["default"].string,
  /**
   * HTML element type
   */
  as: _propTypes["default"].string,
  /**
   * Add extra bottom padding
   */
  isParagraph: _propTypes["default"].bool,
  /**
   * Typography ref
   */
  ref: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  /**
   * Predefined font sizes(small, default, medium, large, attention, max) or pass any possible CSS value
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].oneOf(Object.keys(_constants.sizes))]),
  /**
   * Test id
   */
  testId: _propTypes["default"].string,
  /**
   * Forwarded ref
   */
  forwardedRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func])
};
Typography.defaultProps = {
  children: null,
  color: undefined,
  weight: undefined,
  display: undefined,
  shouldWrap: true,
  align: undefined,
  as: undefined,
  isParagraph: false,
  ref: null,
  size: undefined,
  testId: 'TYPOGRAPHY',
  forwardedRef: null
};
var _default = (0, _oxygenConfig.withTheme)(Typography, _constants.THEME_NAME);
exports["default"] = _default;